export const LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER =
    'LOYALTY_UPGRADE_TO_PRO_BANNER_SHOWN_ON_LISTINGS_AND_EXPIRE_AFTER';
export const THREE_MONTHS_IN_MILLISECONDS = 7776000000;

// Loyalty tiers thresholds
export const GOLD_TIER_THRESHOLD_CENTS = 1000 * 100;
export const PLATINUM_TIER_THRESHOLD_CENTS = 5000 * 100;
